import { render } from "./HeroiconsOutlineDotsCircleHorizontal.vue?vue&type=template&id=c890dffc"
const script = {}

import exportComponent from "C:\\Users\\ernes\\.ssh\\bipay-laravel-reportes\\vendor\\laravel\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineDotsCircleHorizontal.vue"]])

export default __exports__